import type { ReactNode } from "react";

export function AuthLayout({
  title,
  subtitle,
  children,
  admin = false
}: {
  title?: string;
  subtitle: string;
  children: ReactNode;
  admin?: boolean;
}) {
  return (
    <main className="auth-page gradient-bg">
      <div className="floating-orb orb-one" />
      <div className="floating-orb orb-two" />
      <div className="floating-orb orb-three" />
      <div className="auth-shell">
        <div className="auth-brand">
          <img src="/limitx.png" alt="LimitX" className="auth-logo" />
          {title ? <h1>{title}</h1> : null}
          <p>{subtitle}</p>
        </div>
        <div className="glass-card auth-card">
          {admin ? <div className="admin-access-note">Authorized personnel only</div> : null}
          {children}
        </div>
        <p className="auth-footer">© 2026 LimitX Browser. All rights reserved.</p>
      </div>
    </main>
  );
}
